import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link, useParams } from "react-router-dom";
import { ApisService } from "../app/core/apis.service";
import { dataDecrypt, dataEncrypt } from "../app/utils/encryption-helper";
import LoginOtp from "./login-screen";
import { PiArrowLeftBold } from "react-icons/pi";
import { formatDateTimeInIST } from "../components/indiaDateFormate";
import { Card } from "react-bootstrap";
import LOGO from './../assets/images/vyapar_logo.png';
import { TransactionDetailsUI } from "../components/transaction-details-ui";

export const ConfirmationMessage = () => {
    const routerParams = useParams();
    const [invoiceData, setInvoiceData] = useState<any>([]);
    const userData = useSelector((state: any) => state);
    const [isOtpEntered, setIsOtpEntered] = useState(false);
    const [otpReference, setOtpReference] = useState('');
    const [loading, setLoading] = useState<boolean>(false);

    useEffect(() => {
        loadInvoice();
    }, []);

    useEffect(() => {
        if (userData?.UserDataReducer?.otp) {
            setIsOtpEntered(true);
        }
    }, [userData]);

    function formatDateTime(input: string): string {
        let date: Date;

        if (/^\d{4}-\d{2}-\d{2} \d{1,2}:\d{2} (AM|PM)$/i.test(input)) {
            return input;
        }

        if (/^\d{2}\/\d{2}\/\d{4},/.test(input)) {
            const [datePart, timePart] = input.split(",");
            const [day, month, year] = datePart.trim().split("/");
            date = new Date(`${year}-${month}-${day}T${timePart.trim()}`);
        } else {
            date = new Date(input);
        }

        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");

        let hours = date.getHours();
        const minutes = String(date.getMinutes()).padStart(2, "0");
        const ampm = hours >= 12 ? "PM" : "AM";
        hours = hours % 12 || 12;

        return `${year}-${month}-${day} ${hours}:${minutes} ${ampm}`;
    }

    async function loadInvoice(): Promise<void> {
        setLoading(true);
        try {
            const res = await ApisService.getTransactionData('getById_v2', routerParams.id || '');
            const data: any = res.data.data;
            const transactionData = JSON.parse(dataDecrypt(data));
            setInvoiceData([...transactionData]);
            const invoiceId = JSON.parse(dataDecrypt(routerParams.id as string));
            if (transactionData[0]) {
                const preparedReference = dataEncrypt(JSON.stringify({ invoice: invoiceId?.id, id: transactionData[0].id, type: 'invoice' }));
                setOtpReference(preparedReference);
            }
            setLoading(false);
        } catch (error) {
            setLoading(false);
        }
    }

    return (
        <div>
            {loading ? <div className="d-flex justify-content-center align-items-center" style={{ height: "100vh" }}>
                <div className="spinner-border text-secondary" role="status"></div>
            </div> : <div>
                {!isOtpEntered && <LoginOtp reference={otpReference} transactionId={invoiceData[0]?.id} />}
                {isOtpEntered && <>
                    <div className='d-flex justify-content-between p-3 align-items-center' style={{ backgroundColor: "#274472", color: "white" }}>
                        <Link to={`/order/${routerParams.id}`}><span ><PiArrowLeftBold size={22} className='text-white' /></span></Link>
                        <span style={{ lineHeight: "0", textAlign: "center" }}><h4 className="mb-0">Confirmation Messages</h4>
                            {/* <div>
                        <div>
                {('currency_symbol' in (invoiceData[0]?.buyer || {})) ? (
                  <>{invoiceData[0]?.buyer?.name}</>
                ) : ('currency_symbol' in (invoiceData[0]?.seller || {})) ? (
                  <>{invoiceData[0]?.seller?.name}</>
                ) : (
                  <p></p>
                )}
              </div>
              </div> */}
                        </span>
                        <img src={LOGO} alt="" height={60} />
                    </div>
                    <br />
                    <div className='container-fluid'>
                        <div style={{ backgroundColor: "white", borderRadius: "3px" }} className='mb-4'>
                            {/* <Card className='box-shadow rounded-4 '>
                                <Card.Body className='p-2'>
                                    <div className='row text-center'>
                                        <div className='col-md-4 my-2 light-grey-right-border'>
                                            <h6 className='mb-0'>Seller</h6>
                                            <span>{invoiceData[0]?.seller?.name}</span>
                                        </div>
                                        <div className='col-md-4 my-2 light-grey-right-border'>
                                            <h6 className='mb-0'>Txn Date</h6>
                                            <span>{formatDateTimeInIST(invoiceData[0]?.created_date)}</span>
                                        </div>
                                        <div className='col-md-4 my-2'>
                                            <h6 className='mb-0'>Txn Id</h6>
                                            <span>{invoiceData[0]?._id}</span>
                                        </div>
                                    </div>
                                </Card.Body>
                            </Card> */}
                            <TransactionDetailsUI data={[{header: 'Seller',value: invoiceData[0]?.seller?.name},{header: 'Txn Date',value: formatDateTimeInIST(invoiceData[0]?.created_date)},{header: 'Txn Id',value: invoiceData[0]?._id}]} />
                        </div>
                        {(invoiceData?.length > 0 && invoiceData[0]?.order_details?.products.length > 0) && <Card className="box-shadow rounded-4">
                            <Card.Body>
                                <table className="table table-striped">
                                    <thead>
                                        <tr>
                                            <th scope="col">S.No</th>
                                            <th scope="col">Product</th>
                                            <th scope="col">Quantity</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {(invoiceData?.length > 0 && invoiceData[0]?.order_details?.products.length > 0) &&
                                            invoiceData[0]?.order_details?.products.map((item: any, index: number) => (
                                                <tr className="fs-14">
                                                    <th>{index + 1}</th>
                                                    <td>{item?.product_name}</td>
                                                    <td>{item?.quantity} {item?.quantity_in && <span>({item?.quantity_in})</span>}</td>
                                                </tr>))}
                                    </tbody>
                                </table>
                            </Card.Body>
                        </Card>}

                        <h6 className="mt-3 fw-bold fs-15">Message Confirmed</h6>
                        {invoiceData[0]?.discussion?.confirmation_message?.length > 0 && <Card className="rounded-4 box-shadow">
                            <Card.Body>
                                {invoiceData[0]?.discussion?.confirmation_message?.map((item: any, index: any) => (<div>
                                    <div
                                        key={index}
                                        className={`d-flex ${item?.bu === null
                                            ? "justify-content-end"
                                            : (item?.type === "dc_order_placed" ||  item?.type === "dc_order_status")
                                                ? "justify-content-center"
                                                : "justify-content-start"
                                            }`}
                                    >

                                        {(item?.type === "dc_order_placed" ||  item?.type === "dc_order_status") ? <div className="text-center my-1 fs-14">{item?.messages}<div></div>{formatDateTime(item.order_placed_by || item.order_status_date )}</div> : <div className={`p-2 px-3 mb-2  box-shadow m-2 ${item.bu === null
                                            ? "light-green-bg text-end ms-auto user-chart-alignment"
                                            : "bg-light text-start me-auto primary-color customer-chat-alignment"
                                            }`}>{item?.messages}
                                            <div className="fs-12 text-end">{item.bu !== null && <span className="pe-2">{item?.user_name}</span>}{formatDateTime(item.message_date)}</div>
                                        </div>}
                                    </div>
                                </div>
                                ))
                                }
                            </Card.Body>
                        </Card>}

                        <div className='text-center'>
                            <Link to={`/order/${routerParams.id}`}><button className='px-4 py-2 rounded my-2 fs-14'>Track All Steps of This Transaction</button></Link>
                        </div>
                    </div>
                </>}
            </div>}
        </div>
    )
}